import { useState } from 'react';
import { Button, Input } from '@mui/material';

import { useDebug } from 'hooks';

export default function DataGenerator({cards}) {
  const debug = useDebug();
  const [data, setData] = useState([]);

  const handleSaveList = () => {
    const collection = cards.map((card) => ({
      collectorNumber: card.collectorNumber,
      regularQty: card.regularQty || 0,
      foilQty: card.foilQty || 0,
      collected: card.collected || false,
    }));

    setData(collection);
  };

  if (!debug) return null;

  return (
    <>
      <Button
        variant="contained"
        onClick={handleSaveList}
        sx={{ mt: 2 }}
      >
        Generate Data
      </Button>
      <Input
        value={JSON.stringify(data, null, 2)}
        readOnly
        multiline
        rows={10}
        fullWidth
        sx={{ mt: 2 }}
      />
    </>
  );
}
